import React from 'react'

export interface IconProps extends React.HTMLProps<SVGElement> {
  color?: string
}

export const CautionSign = ({ color = '#FF565C', style = {} }: IconProps) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
    <circle cx='8' cy='8' r='8' fill={color} />
    <rect width='11.5556' height='11.5556' transform='translate(2.22266 2.22217)' fill={color} />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.00223 10.6021C7.70175 10.6021 7.45795 10.3652 7.45795 10.0664C7.45795 9.76755 7.70175 9.52508 8.00223 9.52508C8.30272 9.52508 8.54084 9.76755 8.54084 10.0664C8.54084 10.3652 8.30272 10.6021 8.00223 10.6021ZM12.8611 10.0044L9.57276 4.65327C9.39134 4.38826 9.18723 4.15143 8.93777 3.97099C8.6713 3.77928 8.36515 3.6665 8.00229 3.6665C7.63944 3.6665 7.33329 3.77928 7.06115 3.97099C6.81736 4.15143 6.61325 4.38826 6.43183 4.65327L3.12647 10.0326C2.87701 10.5457 2.87701 11.1321 3.1775 11.6227C3.44397 12.0569 3.91454 12.3332 4.4248 12.3332H11.5741C12.09 12.3332 12.5549 12.0569 12.8214 11.6227C13.1219 11.1378 13.1332 10.5062 12.8611 10.0044ZM8.00184 8.98953C7.8034 8.98953 7.66166 8.82601 7.63898 8.62865L7.45756 7.01035C7.42921 6.73405 7.72403 6.47467 8.00184 6.47467C8.27964 6.47467 8.57446 6.73405 8.54044 7.01035L8.35902 8.62865C8.34201 8.82601 8.20027 8.98953 8.00184 8.98953Z'
      fill='white'
    />
  </svg>
)

export default CautionSign
